import { useAppStore } from '../store'

const useAppSkin = () => {
    const { appSkin } = useAppStore() ?? {}

    const { appLoginScreenLogoUrl, appMenuLogoUrl } = appSkin ?? {}

    const appLoginScreenLogo = appLoginScreenLogoUrl
    const appMenuLogo = appMenuLogoUrl

    return { appLoginScreenLogo, appMenuLogo }
}

export default useAppSkin
